import ReactModal from 'react-modal';
import Scrollbar from 'react-scrollbars-custom';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';
import breakPoints from 'helpers/Styles';
import styles from './styles';
import { useState } from 'react';
import Image from 'next/image';

const PcModelModalHelp = ({ isOpen, title, onClose, pcConfigDoc }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const needHelpData = pcConfigDoc?.data?.need_help_description;
  const customLink = (type, element, content, children, index) => (
    <a href={element.data.url}>
      {content}
      <style jsx>
        {`
          a {
            cursor: pointer;
            font-size: 18px;
          }
          a:hover {
            color: #fd0300;
          }
        `}
      </style>
    </a>
  );
  return (
    <>
      <ReactModal
        isOpen={isOpen}
        onRequestClose={onClose}
        className="modal-content"
        overlayClassName="modal-overlay"
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
        preventScroll
        style={{
          overlay: {
            background: 'rgba(255, 255, 255, 0.25)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 100,
          },
          content: {
            margin: '10px',
            borderRadius: '2px',
            minWidth: '50vw',
            overflow: 'hidden',
          },
        }}
      >
        <div className="modal-wrapper modal-helper">
          <div className="modal-header">
            <div className="modal-header-title">{title}</div>

            <div 
              className="modal-header-icon" 
              onClick={onClose}
              onMouseEnter={handleMouseEnter}      
              onMouseLeave={handleMouseLeave}
            >
              <Image 
                src={isHovered ? 
                  "https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-close-hover.png?v=1713886520" 
                  : "https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-close.png?v=1714038756"}
                width={20}
                height={20}
              />
            </div>
          </div>

          <Scrollbar
            translateContentSizesToHolder
            style={{ padding: '30px 0' }}
          >
            <div className="modal-body">
              <RichText render={needHelpData} serializeHyperlink={customLink} />
              {/* {RichText.render(needHelpData)} */}
            </div>
          </Scrollbar>
        </div>
      </ReactModal>

      <style jsx>{styles}</style>

      <style jsx global>
        {`
          .modal-helper .ScrollbarsCustom {
            width: 100%;
          }

          @media (max-width: ${breakPoints.medium}) {
            .modal-helper p {
              max-width: 500px;
              padding: 0 10px;
            }
          }
          @media (max-width: ${breakPoints.small}) {
            .modal-helper p {
              max-width: 320px;
              padding: 0 10px;
            }
          }
        `}
      </style>
    </>
  );
};

PcModelModalHelp.propTypes = {
  title: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  pcConfigDoc: PropTypes.object.isRequired,
};

PcModelModalHelp.defaultProps = {
  title: 'OUR PROFESSIONAL OPINION',
};

export default PcModelModalHelp;
